import { render, staticRenderFns } from "./widgetProduct.vue?vue&type=template&id=096b799e&scoped=true&"
import script from "./widgetProduct.vue?vue&type=script&lang=js&"
export * from "./widgetProduct.vue?vue&type=script&lang=js&"
import style0 from "./widgetProduct.vue?vue&type=style&index=0&id=096b799e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096b799e",
  null
  
)

export default component.exports